import { AUTH_TYPES } from "../auth/authConstants";

export function arrayUniqueById(array) {
  const newArray = [];
  array.forEach(item => {
    const existedItems = newArray.filter(innerItem => item.id === innerItem.id);
    if (existedItems.length === 0) {
      newArray.push(item);
    }
  });
  return newArray;
}

export function hasCurrentUserPermissionByName(permissionKey) {
  const role = localStorage.getItem(AUTH_TYPES.ROLE);
  var roles = localStorage.getItem(AUTH_TYPES.ROLES);
  if(!roles){
    roles= [role]
  }

  if (!roles) {
    return false;
  }
  if (roles.includes("ROOT")) {
    return true;
  }
  return roles.includes(permissionKey);
}
export function toEnglishDigits(object) {
  let str = JSON.stringify(object)

  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  var e = '۰'.charCodeAt(0);
  str = str.replace(/[۰-۹]/g, function (t) {
    return t.charCodeAt(0) - e;
  });

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = '٠'.charCodeAt(0);
  str = str.replace(/[٠-٩]/g, function (t) {
    return t.charCodeAt(0) - e;
  });
  return JSON.parse(str);
}


